import $ from 'jquery';

import {BottomTab} from '../../../legacy/bottom-tab';
import Class from '../../../legacy/legacy-class';

export const DeviceTabContents = Class({
    destroy: function () {},

    element: function () {
        return this._element;
    },

    activated: function () {},
    deactivated: function () {},
});

export const DeviceTab = Class(BottomTab, {
    init: function (ui, options) {
        this._ui = ui;

        this._element = $('<div>', {
            class: 'ui-bottom-tab ' + options.divclass,
            tabtitle: options.tabtitle,
            tabicon: options.tabicon,
            role: options.role,
        });

        this._contentClass = options.contentClass;

        this._contents = {};
        this._activeContent = null;

        this._device_manager_binding = this._ui.devices.bind({
            deviceSelected: this._onDeviceSelected.bind(this),
        });

        if (this._ui.devices.selectedDevice()) this._onDeviceSelected();

        if (options.should_appear) this.should_appear = options.should_appear;
        if (options.should_appear_depends_on)
            this.should_appear_depends_on = function () {
                return options.should_appear_depends_on;
            };
    },

    destroy: function () {
        this._device_manager_binding.unbind();

        for (var device_id in this._contents)
            if (this._contents.hasOwnProperty(device_id))
                this._contents[device_id].destroy();

        this._contents = {};
        this._activeContent = null;
    },

    _onDeviceSelected: function () {
        var device = this._ui.devices.selectedDevice();

        if (device && !this._contents[device.id()])
            this._contents[device.id()] = new this._contentClass(this._ui, {
                device: device,
            });

        if (this.active() && this._activeContent) this._activeContent.deactivated();

        this._activeContent = device ? this._contents[device.id()] : null;

        this._element.children().detach().end();

        if (this._activeContent) this._element.append(this._activeContent.element());

        if (this.active() && this._activeContent) this._activeContent.activated();
    },

    activated: function () {
        if (!this._active) {
            this._active = true;
            if (this._activeContent) this._activeContent.activated();
        }
    },

    deactivated: function () {
        if (this._active) {
            this._active = false;
            if (this._activeContent) this._activeContent.deactivated();
        }
    },
}).implement(
    Class.Properties({
        active: {value: false},
    })
);
